module.exports = __webpack_public_path__ + "static/img/hero-sm.22a9b34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/hero-sm.png
// module id = CFvh
// module chunks = 0